export const environment = {

  production: true,
  firebase: {
    apiKey: "AIzaSyBSVO1JKBNryDf74VJ8ZghDEv3fixD6SQk", // gitleaks:allow
    authDomain: "noovle-preventivatore-eps-prod.firebaseapp.com",
    projectId: "noovle-preventivatore-eps-prod",
    storageBucket: "noovle-preventivatore-eps-prod.appspot.com",
    messagingSenderId: "168671724546",
    appId: "1:168671724546:web:2e245144966c9931e9d31b"
  },
  baseUrl: '/api/v1',
  formIo: {
    apiUrl: 'https://formio.dev.ai-platform.elvoon.it/',
  },
  apiMock: 'http://localhost:4200/public/mock-data',
  lookerDashboardUrl: 'https://lookerstudio.google.com/embed/reporting/3a79eb7f-bc23-4270-ae6f-2e98d06d51d8/page/IuPiF'

};
